module.exports = __webpack_public_path__ + "img/wholesaleIcon6.34d0fcd2.png";